
import XHeader from 'vux/src/components/x-header/index.vue'
import Flow from 'vux/src/components/flow/flow.vue'
import FlowState from 'vux/src/components/flow/flow-state.vue'
import FlowLine from 'vux/src/components/flow/flow-line.vue'

export default {
components:{
XHeader,
Flow,
FlowState,
FlowLine
},
data(){
return{

}
},
methods: {
goBack(){

this.$router.push({
path : '/learn/cooperation/childcloud',
query : {}
})
},
getFree(){
this.$router.push('/learn/buyTryOut')
}
}
}



// WEBPACK FOOTER //
// ./src/views/learn/buySelect.vue